import axios from '../config/axios';
import { CYCLE_BY_PAYMENT_TYPE, LI_ACCUMULATED_BY_PROVIDER_PURCHASES_ELEMENTS, LI_ACCUMULATED_BY_SUPPLIER_PURCHASES, LI_BILLS_BY_BUYER, LI_BILLS_BY_FAMILY, LI_BILLS_BY_FAMILY_ELEMENTS, LI_BILLS_BY_FAMILY_RESET, LI_BILLS_BY_PC, LI_BILLS_BY_PC_GENERAL, LI_BILLS_BY_PC_GENERAL_ELEMENTS, LI_BILLS_BY_PC_GENERAL_ELEMENTS_TWO, LI_BILLS_BY_PC_GENERAL_RESET, LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS, LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD, LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD_RESET, LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_RESET, LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM, LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM_RESET, LI_BILLS_BY_PC_RESET, LI_BILLS_BY_PC_SELECTED_BILLS, LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD, LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD_RESET, LI_BILLS_BY_PC_SELECTED_BILLS_RESET, LI_BILLS_BY_PC_SELECTED_ITEM, LI_BILLS_BY_PC_SELECTED_ITEM_RESET, LI_BILLS_DETAILS_ELEMENTS_TWO, LI_BUYORDER_APPROVALS, LI_BUYORDER_CHANGE, LI_BUYORDER_DATA, LI_BUYORDER_DETAILS, LI_BUYORDER_DETAIL_ORDER, LI_BUYORDER_NOTEPAD_UPDATE, LI_BUYORDER_STORE, LI_BUYORDER_TO_PAY, LI_COINS, LI_COINS_LOADING, LI_COMPANIES, LI_COMPANIES_LOADING, LI_CYCLE_BY_PAYMENT_TYPE_ELEMENTS, LI_ELEMENTS_RESET, LI_ELEMENTS_TWO_RESET, LI_ORDERS_SERVE, LI_PAYMENTS_TYPES_LIST, LI_PERCENTAGE_ATTENDED_ORDERS_ELEMENTS, LI_PERCENTAGE_BY_ORDER_ELEMENTS, LI_PERCENTAGE_BY_ORDER_REQUEST, LI_PERCENTAGE_PRODUCTION_BY_BUYER_ELEMENTS, LI_PERCENTAGE_REQUIREMENT_NUMBERS_ELEMENTS, LI_PROJECTS_BY_COMPANY, LI_PROJECTS_BY_COMPANY_RESET, LI_REQUIREMENTS_ORDER_LIST } from '../constants';
let company = JSON.parse(localStorage.getItem("company-s10"));
let user = JSON.parse(localStorage.getItem("user-s10"));

const signalRequest = async ( requestId, objectName, hasOutputParam ) => {
	const body = {
		HasOutputParam: hasOutputParam || false,
		ObjectName: objectName,
		RequestId: requestId,
		SignalRConnectionID: await localStorage.getItem("connectionId"),
		SecurityUserId: user.IdUser ? user.IdUser : user.UserId, // SecurityUserId obtenido al logear
	};
	const headers = {
		Token: company.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
	};
	
	await axios.post( 
		"",
		body,
		{
			headers: headers,
		}
	);
}

export const getCoinsRequest = () => {
	return async (dispatch, getState) => {
		const state = getState();
		const logisticIndicators = state.logisticIndicators;
		if (logisticIndicators.coinsLoading || logisticIndicators.coins.length) {
			return;
		}
		dispatch({ type: LI_COINS_LOADING });
		await signalRequest(
			LI_COINS,
			`dbo.S10_00_Moneda_ListarPorDescripcion`
		);
	};
};

export const getCompaniesRequest = (startDate, endDate) => {
	const finalStartDate = startDate ? `'${startDate}'` : 'null';
	const finalEndDate = endDate ? `'${endDate}'` : 'null';

	return async (dispatch, getState) => {
		const state = getState();
		const logisticIndicators = state.logisticIndicators;
		if (logisticIndicators.companiesLoading || logisticIndicators.companies.length) {
			return;
		}
		dispatch({ type: LI_COMPANIES_LOADING });
		await signalRequest(
			LI_COMPANIES,
			`dbo.S10_00_Empresa_Listar ${finalStartDate},${finalEndDate}`,
		);
	};
};

export const resetProjetsByCompanyRequest = () => {	
	return ({
		type: LI_PROJECTS_BY_COMPANY_RESET,
	})
}

export const getProjetsByCompanyRequest = async (companyId, startDate, endDate) =>{
	// const finalStartDate = startDate ? `'${startDate}'` : 'null';
	// const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		LI_PROJECTS_BY_COMPANY,
		`dbo.S10_00_GastoProyecto_Listar ''`,
	);
}

export const resetBillsByFamily = () => {	
	return ({
		type: LI_BILLS_BY_FAMILY_RESET,
	})
}

export const getBillsByFamilyRequest = async (codProject, companyId, level, startDate, endDate) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	// const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		LI_BILLS_BY_FAMILY,
		`dbo.S10_00_GastoFamilia_Listar '${codProject}','${companyId}','${level}',50,${finalStartDate}`,
	);
}

export const resetElements = () => {	
	return ({
		type: LI_ELEMENTS_RESET,
	})
}

export const resetElementsTwo = () => {	
	return ({
		type: LI_ELEMENTS_TWO_RESET,
	})
}

export const getBillsByFamilyElementsRequest = async (codProject, codCompany, codItem, startDate, page=1) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_BILLS_BY_FAMILY_ELEMENTS,
		`dbo.S10_00_GastoFamilia_ListarDetalle '','${codProject}','${codCompany}','${codItem}',${finalStartDate},${page},100`,
		true
	);
}

export const getCicleByPaymentTypeElementsRequest = async (codProject, codCompany, orderType, codItem, startDate, page=1) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_CYCLE_BY_PAYMENT_TYPE_ELEMENTS,
		`dbo.S10_00_Gasto_ListarFormaPagoDetalle '${codProject}','${codCompany}',${finalStartDate},${orderType},'${codItem}',${page},100`,
		true
	);
}

export const getPercentageByOrderElementsRequest = async (codProject, codCompany, codItem, startDate, page=1) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_PERCENTAGE_BY_ORDER_ELEMENTS,
		`dbo.S10_00_Gasto_ListarOrdenDetalle '${codProject}','${codCompany}',${finalStartDate},'${codItem}',${page},100`,
		true
	);
}

export const getAccumulatedByPurchasesBySupplierRequest = async (codProject, codCompany, codItem, startDate, page=1) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_ACCUMULATED_BY_PROVIDER_PURCHASES_ELEMENTS,
		`dbo.S10_00_GastoProveedor_ListarDetalle '','${codProject}','${codCompany}','${codItem}',${finalStartDate},${page},100`,
		true
	);
}

export const getPercentageAttendedOrdersRequest = async (codProject, codCompany, codItem, startDate, page=1) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_PERCENTAGE_ATTENDED_ORDERS_ELEMENTS,
		`dbo.S10_00_PedidoCompra_ListarEstadoDetalle '${codProject}','${codCompany}',${finalStartDate},'${codItem}',${page},100`,
		true
	);
}


export const getPercentageProductionByBuyerRequest = async (codProject, codCompany, codItem, startDate, page=1) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_PERCENTAGE_PRODUCTION_BY_BUYER_ELEMENTS,
		`dbo.S10_00_Gasto_ListarPorCompradorDetalle '${codProject}','${codCompany}',${finalStartDate},'${codItem}',${page},100`,
		true
	);
}

export const getPercentageRequirementsNumberRequest = async (codProject, codCompany, codItem, startDate, page=1) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_PERCENTAGE_REQUIREMENT_NUMBERS_ELEMENTS,
		`dbo.S10_00_PedidoCompra_ListarRequerimientoDetalle '${codProject}','${codCompany}',${finalStartDate},'${codItem}',${page},100`,
		true
	);
}


export const getPaymentTypesList = async (startDate, endDate) =>{
	// const finalStartDate = startDate 
	// 	? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
	// 	: 'null';
	// const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		LI_PAYMENTS_TYPES_LIST,
		`dbo.S10_00_FormaDePago_ListarPorDescripcion`,
	);
}

export const getPurchaseOrderListRequest = async (codProject, companyId, startDate, endDate) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	// const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		LI_REQUIREMENTS_ORDER_LIST,
		`dbo.S10_00_PedidoCompra_ListarRequerimiento '${codProject}','${companyId}',${finalStartDate}`,
	);
}

export const getBillsByBuyerRequest = async (codProject, companyId, startDate, endDate) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	// const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		LI_BILLS_BY_BUYER,
		`dbo.S10_00_Gasto_ListarPorComprador '${codProject}','${companyId}',${finalStartDate}`,
	);
}

export const getBOrdersServeRequest = async (codProject, companyId, startDate, endDate) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	// const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		LI_ORDERS_SERVE,
		`dbo.S10_00_PedidoCompra_ListarEstado '${codProject}','${companyId}',${finalStartDate}`,
	);
}

export const getAccumulatedBySupplierPurchasesRequest = async (codProject, companyId, startDate, endDate) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	// const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		LI_ACCUMULATED_BY_SUPPLIER_PURCHASES,
		`dbo.S10_00_GastoProveedor_Listar '${codProject}','${companyId}',20,${finalStartDate}`,
	);
}

export const getPercentageByOrderRequest = async (codProject, companyId, startDate, endDate) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	// const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		LI_PERCENTAGE_BY_ORDER_REQUEST,
		`dbo.S10_00_Gasto_ListarPorcentaje '${codProject}','${companyId}',${finalStartDate}`,
	);
}

export const getCycleByPaymentTypeRequest = async (codProject, companyId, startDate, endDate) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	// const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		CYCLE_BY_PAYMENT_TYPE,
		`dbo.S10_00_Gasto_ListarFormaPago '${codProject}','${companyId}',${finalStartDate}`,
	);
}

export const getBillsDetailsElementsTwoRequest = async (codProject, codCompany, codProvider, codItem, startDate, page=1) =>{
	const finalStartDate = startDate 
		? `'${startDate.split('/')[2]}${startDate.split('/')[1]}${startDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_BILLS_DETAILS_ELEMENTS_TWO,
		`dbo.S10_00_GastoDetalle_Listar '${codProject}','${codCompany}',${finalStartDate},'${codProvider}','${codItem}',${page},100`,
		true
	);
}

export const getBuyOrderDataRequest = async (codItem) =>{
	await signalRequest(
		LI_BUYORDER_DATA,
		`dbo.S10_02_OrdenDeCompra_LeerRegistro '${codItem}'`,
		true
	);
}

export const getBuyOrderChangeRequest = async (startDate, codMoneda) =>{
	await signalRequest(
		LI_BUYORDER_CHANGE,
		`dbo.S10_00_TipoDeCambio_ObtenerValorVenta '${startDate}','${codMoneda}`,
		true
	);
}

export const getBuyOrderDetailsRequest = async (codItem) =>{
	await signalRequest(
		LI_BUYORDER_DETAILS,
		`dbo.s10_02_OrdenDeCompra_ListarDetalle '${codItem}'`,
		true
	);
}

export const getBuyOrderApprovalsDetailsRequest = async (codItem) =>{
	await signalRequest(
		LI_BUYORDER_APPROVALS,
		`dbo.S10_02_OrdenDeCompra_ListarAprobadoresVistoBueno '${codItem}'`,
		true
	);
}

export const getBuyOrdeStoreRequest = async (codItem) =>{
	await signalRequest(
		LI_BUYORDER_STORE,
		`dbo.sp_02ObtenerOrdenDeCompraEnAlmacenes '${codItem}'`,
		true
	);
}

export const getBuyOrdeToPayRequest = async (codItem) =>{
	await signalRequest(
		LI_BUYORDER_TO_PAY,
		`dbo.s10_02_OrdenDeCompra_ListarDocumentosPorPagar '${codItem}'`,
		true
	);
}

export const getBuyOrderDetailsOrderRequest = async (codItem) =>{
	await signalRequest(
		LI_BUYORDER_DETAIL_ORDER,
		`dbo.S10_02_OrdenDeCompra_ListarDetallePedido '${codItem}'`,
		true
	);
}



export const getBuyOrderNotepadUpdateRequest = async (itemCode, hasNote) =>{
	await signalRequest(
		LI_BUYORDER_NOTEPAD_UPDATE,
		`dbo.S10_00_Notero_Actualizar '${itemCode}','OrdenDeCompra',${hasNote}`,
		true
	);
}




export const resetBillsByPC = () => {
	return ({
		type: LI_BILLS_BY_PC_RESET,
	})
}

export const getBillsByPCRequest = async (codProject, level, endDate) =>{
	const finalEndDate = endDate 
		? `'${endDate.split('/')[2]}${endDate.split('/')[1]}${endDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_BILLS_BY_PC,
		`dbo.S10_00_BI_GastoPartidaDeControl_Listar '${codProject}','${level}','0',${finalEndDate}`,
	);
}

export const getBillsByPCSelectedItemRequestReset = () => {
	return ({
		type: LI_BILLS_BY_PC_SELECTED_ITEM_RESET,
	})
}

export const getBillsByPCSelectedItemRequest = async (codProject, codPC, endDate, period) =>{
	const finalEndDate = endDate 
		? `'${endDate.split('/')[2]}${endDate.split('/')[1]}${endDate.split('/')[0]}'` 
		: 'null';
	// const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		LI_BILLS_BY_PC_SELECTED_ITEM,
		`dbo.S10_00_BI_GastoPartidaDeControl_ListarDetalle '${codProject}','${codPC}',${finalEndDate},'${period}'`,
	);
}


export const getBillsByPCSpendResourceReset = () => {
	return ({
		type: LI_BILLS_BY_PC_SELECTED_BILLS_RESET,
	})
}

export const getBillsByPCSpendResourceRequest = async (codProject, codPC, level, endDate, top=50) =>{
	const finalEndDate = endDate 
		? `'${endDate.split('/')[2]}${endDate.split('/')[1]}${endDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_BILLS_BY_PC_SELECTED_BILLS,
		`dbo.S10_00_BI_GastoPC_Recurso_Listar '${codProject}','${codPC}','${level}','${top}',${finalEndDate}`,
	);
}


export const getBillsByPCSpendByPeriodResourceReset = () => {
	return ({
		type: LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD_RESET,
	})
}

export const getBillsByPCSpendResourceByPeriodDetailsRequest = async (codProject, codPC, codItem, period, endDate) =>{
	const finalEndDate = endDate 
		? `'${endDate.split('/')[2]}${endDate.split('/')[1]}${endDate.split('/')[0]}'` 
		: 'null';
		// const finalEndDate = endDate ? `'${endDate}'` : 'null';
		// dbo.S10_00_BI_GastoPartidaDeControl_Listar '13001','1','50','20250916'
		// 3 // dbo.S10_00_BI_GastoPC_Recurso_Listar '13001','99','1','50','20250916'
		// dbo.S10_00_BI_GastoPartidaDeControl_ListarDetalle '13001','99','20250916','1'
		// 4 // dbo.S10_00_BI_GastoPC_Recurso_Periodo_Listar '13001','99','02','1','20250916'
		// dbo.S10_00_BI_GastoPC_Recurso_Periodo_Listar
  		// [{"P":"CodProyecto","O":0},{"P":"CodPartidadeControl","O":1},{"P":"CodInsumo","O":2},{"P":"TipoPeriodo","O":3},{"P":"Fecha","O":4}]
	await signalRequest(
		LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD,
		`dbo.S10_00_BI_GastoPC_Recurso_Periodo_Listar '${codProject}','${codPC}','${codItem}','${period}',${finalEndDate}`,
	);
}



export const resetBillsByPCGeneral = () => {
	return ({
		type: LI_BILLS_BY_PC_GENERAL_RESET,
	})
}

export const getBillsByPCGeneralRequest = async (codProject, level, endDate) =>{
	const finalEndDate = endDate 
		? `'${endDate.split('/')[2]}${endDate.split('/')[1]}${endDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_BILLS_BY_PC_GENERAL,
		`dbo.S10_00_BI_GastoPartidaControlGeneral_Listar '${codProject}','${level}','0',${finalEndDate}`,
	);
}

export const getBillsByPCGeneralSelectedItemRequestReset = () => {
	return ({
		type: LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM_RESET,
	})
}

export const getBillsByPCGeneralSelectedItemRequest = async (codProject, codPC, endDate, period) =>{
	const finalEndDate = endDate 
		? `'${endDate.split('/')[2]}${endDate.split('/')[1]}${endDate.split('/')[0]}'` 
		: 'null';
	// const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM,
		`dbo.S10_00_BI_GastoPartidaControlGeneral_ListarDetalle '${codProject}','${codPC}',${finalEndDate},'${period}'`,
	);
}


export const getBillsByPCGeneralSpendResourceReset = () => {
	return ({
		type: LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_RESET,
	})
}

export const getBillsByPCGeneralSpendResourceRequest = async (codProject, codPC, level, endDate, top=50) =>{
	const finalEndDate = endDate 
		? `'${endDate.split('/')[2]}${endDate.split('/')[1]}${endDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS,
		`dbo.S10_00_BI_GastoPCG_Recurso_Listar '${codProject}','${codPC}','${level}','${top}',${finalEndDate}`,
	);
}


export const getBillsByPCGeneralSpendByPeriodResourceReset = () => {
	return ({
		type: LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD_RESET,
	})
}

export const getBillsByPCGeneralSpendResourceByPeriodDetailsRequest = async (codProject, codPC, codItem, period, endDate) =>{
	const finalEndDate = endDate 
		? `'${endDate.split('/')[2]}${endDate.split('/')[1]}${endDate.split('/')[0]}'` 
		: 'null';
	await signalRequest(
		LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD,
		`dbo.S10_00_BI_GastoPC_Recurso_Periodo_Listar '${codProject}','${codPC}','${codItem}','${period}',${finalEndDate}`,
	);
}

export const getBillsByPCGElementsRequest = async (searchText, codProject, codPC, codItem, endDate, page=1) =>{
	const finalEndDate = endDate 
		? `'${endDate.split('/')[2]}${endDate.split('/')[1]}${endDate.split('/')[0]}'` 
		: 'null';
	// dbo.S10_00_GastoPC_ListarDetalle '','null','14','null','null','20251110',0,1,1
	// [{"P":"Descripcion","O":0},{"P":"CodProyecto","O":1},{"P":"CodPartidaDeControl","O":2},{"P":"CodInsumo","O":3},{"P":"TipoPeriodo","O":4},{"P":"Periodo","O":5},{"P":"Acumulado","O":6},{"P":"NumeroPagina","O":7},{"P":"TamanoPagina","O":8}]
	await signalRequest(
		LI_BILLS_BY_PC_GENERAL_ELEMENTS,
		`dbo.S10_00_GastoPC_ListarDetalle '${searchText || ''}','${codProject || ''}','${codPC || ''}','${codItem || ''}','null',${finalEndDate},0,${page},100`,
		true,
	);
}

export const getBillsByPCGElementsTwoRequest = async (searchText, codProject, codPC, codItem, endDate, page = 1) =>{
	const finalEndDate = endDate 
		? `'${endDate.split('/')[2]}${endDate.split('/')[1]}${endDate.split('/')[0]}'` 
		: 'null';
	// dbo.S10_00_GastoPCxOC_ListarDetalle '','null','9999999999','02041900050004','null','20251110',0,1,50
	// [{"P":"Descripcion","O":0},{"P":"CodProyecto","O":1},{"P":"CodPartidaDeControl","O":2},{"P":"CodInsumo","O":3},{"P":"TipoPeriodo","O":4},{"P":"Periodo","O":5},{"P":"Acumulado","O":6},{"P":"NumeroPagina","O":7},{"P":"TamanoPagina","O":8}]
	await signalRequest(
		LI_BILLS_BY_PC_GENERAL_ELEMENTS_TWO,
		`dbo.S10_00_GastoPCxOC_ListarDetalle '${searchText || ''}','${codProject || ''}','${codPC}','${codItem}','null',${finalEndDate},0,${page},50`,
		true,
	);
}